import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_WEB_API_URL;
axios.defaults.withCredentials = true;

const sessionIdKey = 'kiosk-mobile-session'

export const session = {
  setSessionId: (v) => {
    sessionStorage.setItem(sessionIdKey, v)
  },
  getSessionId: () => sessionStorage.getItem(sessionIdKey)
}

// intercept requests to set sessionId
axios.interceptors.request.use((request) => {
  request.headers = { 'X-session-id': session.getSessionId() }
  return request;
});

// intercept response for error handling
axios.interceptors.response.use((response) => {
  if (response && response.status === 403) {
    return window.location.href = '/'
  }
  return response;
}, (error) => {
  if (error.response && error.response.status === 403) {
    return window.location.href = '/'
  }
  if (error.response && error.response.data) {
    return Promise.reject(error.response.data);
  }
  return Promise.reject(error.message);
});
